import { Merchant } from "@/dto/merchant";
import Image from "next/image";
import DefaultLogoIcon from "@/components/_icons/defaultLogoIcon";

export interface CartMerchantInfoProps {
  className?: string;
  merchant: Merchant;
}
export const CartMerchantInfo = ({
  className,
  merchant,
}: CartMerchantInfoProps) => {
  const { logo, address, name } = merchant;

  return (
    <div
      className={`pt-[25px] pb-[1px] flex items-center gap-[18px] px-4 ${className}`}
    >
      {logo ? (
        <Image
          className={"w-[50px] h-[50px]"}
          src={logo}
          alt={name}
          width={50}
          height={50}
        />
      ) : (
        <DefaultLogoIcon className="w-[50px] h-[50px]" aria-label={name} />
      )}
      <div>
        <p className="text-2xl font-medium font-[#373737]">{name}</p>
        <span className="text-[15px] leading-6 font-normal font-[#373737]">{`${address.address1}, ${address.city}`}</span>
      </div>
    </div>
  );
};
